import PostEventViewSection from '@src/components/layout/admin/sections/post-event';
import React from 'react';

export default function PostEventPage() {
    return <PostEventViewSection title="คำขอกิจกรรมประเภท Post-Event" />;
}
